/** Types */
export const GET_PATIENTS = "GET_PATIENTS";
export const GET_PATIENTS_SUCCESS = "GET_PATIENTS_SUCCESS";
export const GET_SINGLE_PATIENT = "GET_SINGLE_PATIENT";
export const GET_SINGLE_PATIENT_SUCCESS = "GET_SINGLE_PATIENT_SUCCESS";
export const ADD_PATIENT = "ADD_PATIENT";
export const EDIT_PATIENT = "EDIT_PATIENT";
export const DELETE_PATIENT = "DELETE_PATIENT";
export const CHANGE_STATUS_PATIENTS = 'CHANGE_STATUS_PATIENTS'
